module.exports = __webpack_public_path__ + "img/dkf1.29c72615.png";